function r(){const r=new URLSearchParams(window.location.search),n={};return r.forEach(((r,c)=>{n[c]=r})),n}function n(r){return r.trim().replace(/\s+/g," ")}export{n as customTrim,r as getQueryParams};
